import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--narrow js-main-content" }
const _hoisted_2 = { class: "_mb-2" }
const _hoisted_3 = { class: "gfu-grid gfu-grid--gutter" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_account_navigation = _resolveComponent("account-navigation")
  const _component_search_title = _resolveComponent("search-title")
  const _component_search_field = _resolveComponent("search-field")
  const _component_system_notification_management_settings = _resolveComponent("system-notification-management-settings")
  const _component_adfound_notification_management_settings = _resolveComponent("adfound-notification-management-settings")
  const _component_subscribed_creator_management_settings = _resolveComponent("subscribed-creator-management-settings")
  const _component_load_more_trigger = _resolveComponent("load-more-trigger")
  const _component_base_view = _resolveComponent("base-view")

  return (_openBlock(), _createBlock(_component_base_view, { "is-processing": _ctx.isProcessing }, {
    default: _withCtx(() => [
      _createVNode(_component_account_navigation, { "page-identity": _ctx.pageID }, null, 8 /* PROPS */, ["page-identity"]),
      _createElementVNode("main", _hoisted_1, [
        _createVNode(_component_search_title, {
          title: _ctx.Resources.SubscriptionManagement.PageHeader,
          "total-item-count": $options.userSubscriptionCount
        }, null, 8 /* PROPS */, ["title", "total-item-count"]),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.Resources.SubscriptionManagement.PageIntroParagraph), 1 /* TEXT */),
        _createVNode(_component_search_field, {
          "model-value": _ctx.searchingPhase,
          "onUpdate:modelValue": $options.onInput,
          "data-qa": "search-field"
        }, null, 8 /* PROPS */, ["model-value", "onUpdate:modelValue"]),
        _createElementVNode("div", _hoisted_3, [
          ($options.showSystemNotificationFields)
            ? (_openBlock(), _createBlock(_component_system_notification_management_settings, _mergeProps({ key: 0 }, $options.systemNotificationProps, { onSystemNotificationPreferenceChange: $options.updateUserSubscription }), null, 16 /* FULL_PROPS */, ["onSystemNotificationPreferenceChange"]))
            : _createCommentVNode("v-if", true),
          ($options.showAdfoundNotificationFields)
            ? (_openBlock(), _createBlock(_component_adfound_notification_management_settings, _mergeProps({ key: 1 }, $options.adfoundNotificationProps, { onAdfoundNotificationPreferenceChange: $options.updateUserSubscription }), null, 16 /* FULL_PROPS */, ["onAdfoundNotificationPreferenceChange"]))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.subscribedCreatorsToShow, (creator) => {
            return (_openBlock(), _createBlock(_component_subscribed_creator_management_settings, _mergeProps({ ref_for: true }, creator, {
              key: creator.creatorID,
              onProjectNotificationPreferenceChange: $options.updateUserSubscription
            }), null, 16 /* FULL_PROPS */, ["onProjectNotificationPreferenceChange"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        ($options.canLoadMoreRows)
          ? (_openBlock(), _createBlock(_component_load_more_trigger, {
              key: 0,
              onLoadMore: $options.loadMoreRows
            }, null, 8 /* PROPS */, ["onLoadMore"]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-processing"]))
}